import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Sidebar from "./layout/Sidebar";
import { message } from "antd";
import { useEffect, useState} from "react";
import { Box, Button, TextInput } from "@strapi/design-system";
import { Grid, GridItem } from "@strapi/design-system/Grid";
import { actAsUser, getProfile } from "../util/API";
import { useNavigate } from "react-router-dom";
import { setUserInfo, setIsActAsUser } from "../redux/action/app";
import { useDispatch } from "react-redux";

const ActAsUser = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const userInfo = useSelector((state) => state.app.userInfo);
  const [messageApi, contextHolder] = message.useMessage();
  const [actAsUserID, setActAsUserID] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  if (!userInfo) {
    return <div>Loading...</div>;
  }

  const getUserInfo = async () => {
    try {
      const response = await getProfile();
      dispatch(setUserInfo(response.data));
    } catch (error) {
      console.error(error);
      // TODO: Handle error while fetching profile
    }
  };

  const handleSubmit = async (e) => {
    const response = await actAsUser({actAsUserID});

    if (response.status === 200) {
      const { user, jwt, current_user } = response.data;
      localStorage.setItem("token", jwt);
      localStorage.setItem("user", JSON.stringify(user));
      dispatch(setIsActAsUser(true))
      await getUserInfo();
      messageApi.open({
        type: "success",
        content: "Cập nhật ngày đóng đề cử thành công.",
      });
      if (lng === "en") navigate(`/nomination/profile`);
      else navigate(`/nomination/ho-so`);
    }
  }

  return (
    <div>
      <div>
        <br />
        <div className="main-wrapper">
          <Sidebar role={userInfo?.role} />
          <div className="main-panel-lg">
              {(userInfo?.role?.type === "secretariat" || userInfo?.role?.type === "admin")&& (
                <Box padding={4}>
                <Grid gridCols={3} gap={5}>
                  <GridItem col={1} s={12} xs={12}>
                    <TextInput
                      value={actAsUserID}
                      name="act_as_user_id"
                      label={t("Act as userID")}
                      onChange={(e) => setActAsUserID(e.target.value)}
                    />
                  </GridItem>
  
                  <div className="custom-box">
                    <Button className="btnSave" onClick={handleSubmit}>
                      {t("str_submit")}
                    </Button>
                  </div>
                </Grid>
              </Box>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActAsUser;
